// extracted by mini-css-extract-plugin
module.exports = {"taxesfooter":"footer-module__taxesfooter___2wyV6"};